"use strict";

var Travels = {
  onload: document.addEventListener('DOMContentLoaded', function () {
    Travels.init();
  }),
  init: function init() {
    this.bind();
    this.initDatePickers();
  },
  bind: function bind() {
    $(document).on('click', 'input[name="travel_companion_check"]', function () {
      $(this).closest('div.form-step__price').find('div.form-step__number').toggle();
      $('span[data-name="travel_companion"]').toggle();
      $('span[data-name-title="travel_companion_check"]').toggle();
      if (this.checked) {
        $(this).closest('div.form-step__price').find('div.form-step__number input').prop('disabled', false);
      } else {
        $(this).closest('div.form-step__price').find('div.form-step__number input').prop('disabled', true);
      }
    }).on('click', '.trip-full-load', function (event) {
      var hash = $(this).closest('a.travels__cart').attr('id');
      if ($(this).is(':checked')) {
        event.preventDefault();
        $('#fully-load-confirmation').attr('data-hash', hash);
        setTimeout(function () {
          $('.full-load-popup').show();
        }, 100);
      } else {
        Travels.ajax.changeFullLoadStatus(0, hash, $(this));
      }
    }).on('click', '#fully-load-confirmation', function (event) {
      event.preventDefault();
      Travels.ajax.changeFullLoadStatus(1, $(this).attr('data-hash'), $(this));
    }).on('click', '.open-archive-trip-popup', function (event) {
      event.preventDefault();
      var hash = $(this).closest('a.travels__cart').attr('id');
      $('#cancel-trip-confirmation').attr('data-hash', hash);
      setTimeout(function () {
        $('.archive-trip').show();
      }, 100);
    }).on('click', '#cancel-trip-confirmation', function (event) {
      var _$$closest$find$val;
      event.preventDefault();
      var reason = (_$$closest$find$val = $(this).closest('form').find('textarea').val()) !== null && _$$closest$find$val !== void 0 ? _$$closest$find$val : '';
      var hash = $(this).attr('data-hash');
      Travels.ajax.cancelTrip(hash, reason);
    });
  },
  initDatePickers: function initDatePickers() {
    var calendar = flatpickr("#travelStartDate", {
      dateFormat: 'd.m.Y H:i',
      enableTime: true,
      minuteIncrement: 15,
      time_24hr: true,
      allowInput: false,
      // minDate: Client.addMinutes(new Date(), 120),
      minDate: Client.addMinutes(new Date(), 15),
      // maxDate:  new Date().fp_incr(14) // 14 days from now
      clickOpens: false,
      disableMobile: "true"
    });
    $('.open-to-date svg').on('click', function () {
      $('.open-to-date svg').toggleClass('display-block');
      if ($('.open-to-date svg').hasClass("display-block")) {
        setTimeout(function () {
          calendar.open();
        }, 0);
      } else {
        setTimeout(function () {
          calendar.close();
        }, 0);
      }
    });
    if ($('#travelStartDate').length > 0) {
      document.getElementById('travelStartDate').addEventListener("click", function (ev) {
        if (calendar.isOpen) {
          calendar.close();
        } else {
          calendar.open();
        }
      });
    }
  },
  initFinishDatePicker: function initFinishDatePicker() {
    var calendar = flatpickr("#travelFinishDate", {
      dateFormat: 'd.m.Y',
      time_24hr: true,
      allowInput: false,
      minDate: $('#travelStartDate').val(),
      clickOpens: false,
      disableMobile: "true"
    });
    $('.travelFinishDate svg').on('click', function () {
      $('.travelFinishDate svg').toggleClass('display-block');
      if ($('.travelFinishDate svg').hasClass("display-block")) {
        calendar.open();
      } else {
        calendar.close();
      }
    });
    document.getElementById('travelFinishDate').addEventListener("click", function (ev) {
      if (calendar.isOpen) {
        calendar.close();
      } else {
        calendar.open();
      }
    });
  },
  ajax: {
    obj: {},
    url: TRAVEL_AJAX_URL,
    send: function send(success, failure) {
      var _this = this;
      $.post(this.url, this.obj, function (answer) {
        _this.obj = {};
        answer.result && typeof success === 'function' ? success(answer) : !answer.result && typeof failure === 'function' ? failure(answer) : null;
      }, 'JSON');
    },
    changeFullLoadStatus: function changeFullLoadStatus(status, hash, field) {
      this.obj.method = 'changeFullLoadStatus';
      this.obj.status = status;
      this.obj.hash = hash;
      this.send(function (answer) {
        Notify.successfulNotification(answer.text);
        $('.full-load-popup').fadeOut(Main.animationParams);
        if (status === 1) {
          setTimeout(function () {
            location.reload();
          }, 600);
          // field.prop('checked', true);
        } else {
          console.log('0');
        }
      }, function (answer) {
        Notify.dangerNotification(answer.text);
      });
    },
    cancelTrip: function cancelTrip(hash, reason) {
      this.obj.method = 'cancelTrip';
      this.obj.reason = reason;
      this.obj.hash = hash;
      this.send(function (answer) {
        $('.archive-trip').fadeOut(Main.animationParams);
        Notify.successfulNotification(answer.text);
        setTimeout(function () {
          location.reload();
        }, 600);
      }, function (answer) {
        $.each(answer.errors, function (name, value) {
          Step.showErrors(name, value);
        });
        Notify.dangerNotification(answer.text);
      });
    }
  }
};